<template>
    <div class="base-footer-wrapper">
        <div class="main">
            <div class="logo">
                <img src="@/assets/images/logo.png" alt="">
            </div>
            <div class="menu flex-start">
                <div class="items" v-for="(parent, parentIndex) in menu" :key="parentIndex">
                    <div class="title">{{ parent.title }}</div>
                    <div class="list">
                        <div class="child flex-start" :class="[child.className]"
                            @click="gotodetail(child.id, child.url, child.target)"
                            v-for="(child, childIndex) in parent.list" :key="childIndex">
                            <img class="icon" v-if="child.icon" :src="child.icon" alt="">
                            {{ child.title }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="info flex-bt">
                <span>@2023 LOOPSHOP TECHNOLOGY COMPANY LIMITED All rights reserved.</span>
                <div class="right flex-end">
                    <a target="_blank" :href="webset.facelink" class="items">
                        <img src="@/assets/images/facebook.png" alt="">
                    </a>
                    <a target="_blank" :href="webset.inslink" class="items">
                        <img src="@/assets/images/ins.png" alt="">
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            webset: [],
            menu: [

            ]
        }
    },

    methods: {
        async getBootList(exmenu) {
            //http://loopw7.w7ad.com/app/index.php?i=3&c=entry&m=tvp_appcenter&do=helplist&sjk=helplist&onemulu=%E9%A0%BB%E9%81%93%E5%B0%88%E5%93%A1 
            let fdata = { do: 'bootmenu', orderby: 'id asc', limit: 10 }
            let res = await this.$api.funk(fdata)
            this.menu = res.map(i => {
                if (i.title == '聯絡我們') {
                    i.list = [
                        { title: 'Email', target: 'email', url: this.webset.email, id: '1', icon: '/video/images/email.png' },
                        { title: 'Facebook', target: '_blank', url: this.webset.facelink, id: '2', icon: '/video/images/facebook.png' },
                        { title: 'Whatsapp', target: '_blank', url: 'https://api.whatsapp.com/send?phone=' + this.webset.whatsapp + '&msg=' + this.webset.sayhi, id: '3', icon: '/video/images/whatsapp.png' },
                        { title: '工作時間', target: '_blank', url: '', id: '3', icon: '', className: 'bold' },
                        { title: this.webset.gzr, target: '_blank', url: 'null', id: '3', icon: '' },
                        { title: this.webset.xxr, target: '_blank', url: 'null', id: '3', icon: '' },
                    ]
                }
                return i
            })

        },
        async getSet() {
            console.log('go...');
            let fdata = { do: 'getSet', goto: 'webset' }
            let res = await this.$api.funk(fdata)
			if(res){
				  this.webset = res
				  this.getBootList()
			}
            
        },
        gotodetail(id, url, target) {
            if (url == 'null') return false;
            if (target) {
                if (target == 'email') {
                    window.location = `mailto:sample@jsphp.net?subject=test&cc=${url}&subject=主题&body=内容`
                } else {
                    window.location.href = url
                }
                return false
            }
            if (url) {
                this.$router.push({ path: '/' + url })
            } else {
                if (id == 16) {
                    this.$router.push({ name: 'terms', params: { id } })
                } else {
                    this.$router.push({ name: 'privacy', params: { id } })
                }
            }

        }
    },
    created(option) {
        this.getSet()
      

    },

}
</script>
<style lang="scss" scoped>
.base-footer-wrapper {
    background: #FFFFFF;
    padding-top: 0.8rem;
    padding-bottom: 0.88rem;

    .bold {
        font-weight: bold !important;
        ;
    }

    .logo {
        width: 1.04rem;
        height: 0.48rem;

        img {
            width: 100%;
            height: 100%;
            display: block;
        }
    }

    .info {
        border-top: 1px solid #000000;
        padding-top: 0.2rem;
        font-family: 'PingFang HK';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 12px;
        color: #000000;
        margin-top: 0.96rem;

        .right {
            .items {
                width: 0.48rem;
                height: 0.48rem;
                display: block;
                margin-left: 0.24rem;
                cursor: pointer;

                img {
                    width: 100%;
                    height: 100%;
                    display: block;
                }
            }
        }
    }

    .menu {
        margin-top: 0.46rem;
        align-items: inherit;

        .items {
            min-width: 1.97rem;
            margin-right: 0.2rem;


            .title {
                font-family: 'PingFang HK';
                font-style: normal;
                font-weight: 600;
                font-size: 0.2rem;
                line-height: 0.28rem;
                color: #000000;
                margin-bottom: 0.24rem;
            }

            .list {
                .child {
                    font-family: 'PingFang HK';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 0.12rem;
                    line-height: 0.17rem;
                    margin-bottom: 0.08rem;
                    color: #000000;
                    cursor: pointer;

                    .icon {
                        width: 0.2rem;
                        display: block;
                        margin-right: 0.08rem;
                    }

                }
            }
        }
    }
}

@media (min-width: 750px) and (max-width: 1200px) {
    .base-footer-wrapper .main {
        width: 100%;
        padding: 0 0.4rem;
    }

    .base-footer-wrapper .menu .items .list .child {
        line-height: inherit;
    }

    .base-footer-wrapper .menu {
        justify-content: space-between;
    }

}

@media (max-width: 750px) {
    .base-footer-wrapper .logo {
        width: 2rem;
        height: auto;
    }

    .base-footer-wrapper .menu {
        margin-top: 0.8rem;
        flex-wrap: wrap;
    }

    .base-footer-wrapper .menu .items {
        margin-bottom: 0.8rem;
        width: 30%;
    }

    .base-footer-wrapper .menu .items .title {
        font-size: 0.32rem;
        line-height: 0.32rem;
    }

    .base-footer-wrapper .menu .items .list .child {
        font-size: 0.2rem;
        line-height: 0.24rem;
    }

    .base-footer-wrapper .info {
        margin-top: 0;
    }

    .base-footer-wrapper .info .right .items {
        width: 0.92rem;
        height: 0.92rem;
    }

}
</style>